import { getEnv } from 'common-nextjs';

/**
 * Bing UET's script code without loading the actual script.
 * This sets up capturing events until the real script loads.
 *
 * See also: BingScript.tsx
 */
export function setupBingLocalCapture() {
  // @ts-ignore
  if (window.UET || window.uetq) return;

  // @ts-ignore
  window.uetq = window.uetq || [];

  // Override push method to add logging
  // @ts-ignore
  const originalPush = window.uetq.push;
  // @ts-ignore
  window.uetq.push = function () {
    if (getEnv() !== 'production') {
      console.log(
        '[Bing Local] uetq.push called with args:',
        Array.prototype.slice.call(arguments, 0),
      );
    }
    // @ts-ignore
    return originalPush.apply(this, arguments);
  };
}

/**
 * Initializes Bing UET after the script has loaded.
 * Called from BingScript.tsx onLoad callback.
 */
export function initializeBingUET() {
  const key = getEnv('BING_KEY');
  if (!key) {
    if (getEnv() !== 'production') {
      console.log('[Bing] No BING_KEY found, skipping initialization');
    }
    return;
  }

  // @ts-ignore
  if (window.UET) {
    const o = { ti: key };
    // @ts-ignore
    o.q = window.uetq;
    if (getEnv() !== 'production') {
      console.log('[Bing] UET initialized with key:', key);
    }
    // @ts-ignore
    window.uetq = new UET(o);
    // @ts-ignore
    window.uetq.push('pageLoad');
  }
}
